import { render, staticRenderFns } from "./AlertDiscountProcess.vue?vue&type=template&id=d621c8e6&scoped=true&"
import script from "./AlertDiscountProcess.vue?vue&type=script&lang=ts&"
export * from "./AlertDiscountProcess.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDiscountProcess.vue?vue&type=style&index=0&id=d621c8e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d621c8e6",
  null
  
)

export default component.exports